module.exports = __webpack_public_path__ + "img/PL08619.9ad374b5.png";